import {
  AccountPage,
  LoginProvider,
  useLoginContext,
} from '@schamburg-web/lakecounty';
import React, { useEffect } from 'react';
import LoginForm from './LoginForm';

const LoginCheck: React.FC = () => {
  return (
    <LoginProvider>
      <LoginCheck2 />
    </LoginProvider>
  );
};

const LoginCheck2: React.FC = () => {
  const { user, initalized } = useLoginContext();

  // Only redirect to /notification on first load, then stop
  useEffect(() => {
    fetch(`${import.meta.env.VITE_REACT_APP_API_HOST}/account/user`, {
      credentials: 'include',
      redirect: 'manual',
    });
  }, []);

  if (!initalized) {
    return <div>Loading...</div>;
  }

  if (user.username !== '') {
    return <AccountPage />;
  } else {
    return <LoginForm />;
  }
};

export default LoginCheck;
